document.addEventListener('DOMContentLoaded', function() {
    const burgerButton = document.getElementById('burger'); // The ID of your burger button
    if (!burgerButton) {
        console.warn('Burger button with ID "burger" not found.');
        return;
    }

    let lastScrollTop = 0;
    const scrollThreshold = 10; // Minimum scroll distance to trigger hide/show
    const topThreshold = 20; // Increased threshold to better detect top of page

    function throttle(func, limit) {
        let inThrottle;
        return function() {
            const args = arguments;
            const context = this;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => inThrottle = false, limit);
            }
        }
    }

    const handleScroll = () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // Always ensure the burger is visible when at or near the top of the page
        if (scrollTop <= topThreshold) { 
            // Increased threshold for more reliable detection of being at the top
            burgerButton.classList.remove('burger-hidden');
            lastScrollTop = scrollTop;
            return;
        }

        if (Math.abs(scrollTop - lastScrollTop) <= scrollThreshold) {
            return; // Not enough scroll to trigger
        }

        if (scrollTop > lastScrollTop && scrollTop > burgerButton.offsetHeight) {
            // Scrolling Down and past the header height (approx)
            burgerButton.classList.add('burger-hidden');
        } else {
            // Scrolling Up
            burgerButton.classList.remove('burger-hidden');
        }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    };

    // Run once on page load to ensure correct initial state
    handleScroll();
    
    // Add a listener for when page visibility changes - important for mobile browsers
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
            // When page becomes visible again, check if we're at the top
            setTimeout(() => {
                const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
                if (currentScroll <= topThreshold) {
                    burgerButton.classList.remove('burger-hidden');
                }
            }, 100);
        }
    });

    window.addEventListener('scroll', throttle(handleScroll, 100), false);
    
    // Also check on window resize events, which can happen when mobile browsers show/hide their UI
    window.addEventListener('resize', throttle(() => {
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        if (currentScroll <= topThreshold) {
            burgerButton.classList.remove('burger-hidden');
        }
    }, 200), false);
});
